import { ReactNode } from 'react';
import { ModalDialog } from './modalDialog.tsx';


interface Props {
    isOpen: boolean;
    isSubmitting?: boolean;
    children: ReactNode;
    frameClassName?: string;
    frameStyle?: React.CSSProperties;
    contentClassName?: string;
    contentStyle?: React.CSSProperties;
    submitButtonText?: string;
    onCancel: () => void;
    onSubmit: () => void;
}

export function ModalSubmitDialog({
    isOpen,
    isSubmitting,
    children,
    frameClassName,
    frameStyle,
    contentClassName,
    contentStyle,
    submitButtonText,
    onCancel,
    onSubmit,
}: Props) {

    const buttonsDisabled = isSubmitting || false;


    return (
        <ModalDialog
            isOpen={isOpen}
            frameClassName={frameClassName}
            frameStyle={frameStyle}
            contentClassName={contentClassName}
            contentStyle={contentStyle}
            onCancel={onCancel}
        >
            {children}

            <div className='dialog--button-bar'>
                <button onClick={onCancel} disabled={buttonsDisabled}>Cancel</button>
                <button onClick={onSubmit} disabled={buttonsDisabled}>
                    {submitButtonText ?? (isSubmitting ? 'Submitting...' : 'Submit')}
                </button>
            </div>
        </ModalDialog>
    )
}
